window.addEventListener("load", () => {
  const containers = document.querySelectorAll('.wp-block-nhr-tabs');
  containers.forEach(container => {
    var selectedTab = 0;
    const tabLabel = container.querySelectorAll('.tab-label');
    const tabItemContent = container.querySelectorAll('.wp-block-nhr-tabs-item');

    tabLabel.forEach((item, i) => {
      tabItemContent[i].style.display = 'none';
      item.addEventListener('click', () => {
        tabItemContent[selectedTab].style.display = 'none';
        tabLabel[selectedTab].classList.remove('selected-tab');
        selectedTab = i;

        tabItemContent[selectedTab].style.display = 'block';
        tabLabel[selectedTab].classList.add('selected-tab');
      })
    })
    tabItemContent[0].style.display = 'block';
    tabLabel[0].classList.add('selected-tab');
  });
});